import { PayPalScriptProvider, PayPalButtons, PayPalMessages } from "@paypal/react-paypal-js";
import { useRef } from "react";
import { toast } from "sonner";
import { api, errMsg } from "@/lib/api";
import { useLang } from "@/lib/i18n";

export function PayPalPay({ clientId, amount, disabled, validate, startOrder, onPaid, onReset }) {
  const ref = useRef(null);
  const { t, lang } = useLang();
  const options = { clientId, currency: "EUR", intent: "capture", locale: lang === "en" ? "en_GB" : "fr_FR", components: "buttons,messages", "enable-funding": "paylater" };

  return (
    <div data-testid="paypal-pay" className="relative z-0">
      <PayPalScriptProvider key={lang} options={options}>
        <PayPalMessages style={{ layout: "text", color: "white" }} amount={amount} className="mb-3" />
        <PayPalButtons
          style={{ layout: "vertical", color: "gold", shape: "pill", label: "pay", height: 48 }}
          disabled={disabled}
          forceReRender={[amount, disabled]}
          onClick={(_, actions) => (validate() ? actions.resolve() : actions.reject())}
          createOrder={async () => {
            const data = await startOrder();
            ref.current = data?.reference;
            return data?.paypal_order_id;
          }}
          onApprove={async (_, actions) => {
            try {
              const { data } = await api.post("/paypal/capture", { reference: ref.current });
              if (data?.payment_status === "paid") return onPaid(ref.current);
              toast.error(t(data?.payment_error || "Le paiement n'a pas pu être confirmé."));
              return onReset();
            } catch (e) {
              if (e?.response?.data?.detail === "INSTRUMENT_DECLINED") return actions.restart();
              toast.error(t(errMsg(e)));
              return onReset();
            }
          }}
          onCancel={async () => {
            if (ref.current) await api.post(`/orders/${ref.current}/cancel`).catch(() => null);
            toast(t("Paiement PayPal annulé. Votre panier est conservé."));
            onReset();
          }}
          onError={() => {
            toast.error(t("PayPal a rencontré une erreur. Merci de réessayer."));
            onReset();
          }}
        />
      </PayPalScriptProvider>
    </div>
  );
}
